<template>
  <select
    ref="selectEl"
    class="form-select"
    :data-placeholder="placeholder"
  >
    <option
      v-for="item in items"
      :key="item.id"
      :value="item.id"
    >
      {{ item.text }}
    </option>
  </select>
</template>

<script lang="ts" setup>
import {onBeforeUnmount, onMounted, useTemplateRef, watch} from 'vue'
import $ from 'jquery'
import {initializeAutocompleteField} from "@/js/site-utils";

export interface DropdownItem {
  id: string
  text: string
}

const model = defineModel<string>({required: true})

defineProps({
  items: {type: Array as () => DropdownItem[], default: (): DropdownItem[] => []},
  placeholder: {type: String},
})

const selectEl = useTemplateRef<HTMLSelectElement>("selectEl")
let select2Instance: HTMLSelectElement | null = null

watch(model, (newValue) => {
  if (select2Instance) {
    $(select2Instance).val(newValue)
    $(select2Instance).trigger("change")
  }
})

onMounted(() => {
  if (!selectEl.value) {
    return
  }

  select2Instance = selectEl.value

  const closestModal = select2Instance.closest(".modal-dialog") as HTMLElement

  initializeAutocompleteField(select2Instance, closestModal)

  $(select2Instance).val(model.value)
  $(select2Instance).trigger("change")

  $(select2Instance).on("change.select2", function (e) {
    const selection = $(e.target).select2("data")
    if (selection.length > 0) {
      model.value = selection[0].id
    } else {
      model.value = ""
    }
  })
})

onBeforeUnmount(() => {
  if (select2Instance) {
    $(select2Instance).select2("destroy")
    select2Instance = null
  }
})

</script>
